import React, { useEffect } from 'react'
import DropZone from './DropZone'
import { Tooltip } from 'react-tooltip'
import dayjs from 'dayjs'
import dayjsPluginUTC from 'dayjs-plugin-utc'
import dayjsTimezone from 'dayjs/plugin/timezone'
import domtoimage from 'dom-to-image'
// Tranlations
import t from '../../translations'

dayjs.extend(dayjsPluginUTC)
dayjs.extend(dayjsTimezone)
const localTimezone = dayjs.tz.guess()

const DragItem = (props) => {

  let statusIcon ={
    type: 'regular',
    name: 'question-mark',
    color: 'grey',
  }
  
  switch(props.status){
    case 'created':
      statusIcon = {
        type: 'regular',
        name: 'bulb',
        color: 'grey',
        size: 'sm',
      }
    break

    case 'started':
      statusIcon = {
        type: 'regular',
        name: 'run',
        color: 'orange',
        size: 'sm',
      }
    break

    case 'finished':
      statusIcon = {
        type: 'regular',
        name: 'check',
        color: 'green',
        size: 'md',
      }
    break

    case 'cancelled':
      statusIcon = {
        type: 'regular',
        name: 'x',
        color: 'red',
        size: 'md',
      }
    break

    // Categories
    default:
      statusIcon = {
        type: 'regular',
        name: 'shape-square',
        color: 'grey',
        size: 'sm',
      }
  }

  const elementFromGroup = props.dataIndexes[0]
  const elementOrderInGroup = props.dataIndexes[props.dataIndexes.length - 1]
  const localUpdatedAt = dayjs(props.updatedAt).utc('z').local().tz(localTimezone).format('YYYY-MM-DD HH:mm')

  const isSelectingStatus = props.isSelectingStatus?.[0] === elementFromGroup && props.isSelectingStatus?.[1] === elementOrderInGroup

  useEffect(() => {
    const target = document.querySelector(`div[data-element-group='${elementFromGroup}'][data-element-index='${elementOrderInGroup}']`)
    const imgId = `${elementFromGroup}-${elementOrderInGroup}`

    const draggedFromGroup = +JSON.parse(localStorage.getItem('dragFrom'))?.groupFrom
    const draggedToGroup = +JSON.parse(localStorage.getItem('dragTo'))?.groupTo
    const imageExists = document.querySelector(`#dragImages .itemImg[data-img-id='${imgId}']`)

    if((!imageExists) || (imageExists && (elementFromGroup === draggedFromGroup || elementFromGroup === draggedToGroup))){
      domtoimage.toPng(target)
      .then(function (dataUrl) {
        // console.log('rerendering', imgId)
        const img = new Image()
        img.src = dataUrl
        img.setAttribute('data-img-id', `${imgId}`)
        img.classList.add('itemImg')
  
        if(!imageExists){
          document.querySelector('#dragImages').append(img)
        }else{
          imageExists.replaceWith(img)
        }
      })
      .catch(function (error) {
        console.error('Error with domtoimage', error);
      });
    }
    
  }, [elementFromGroup, elementOrderInGroup])

  return <>
    <DropZone
      elementOrderInGroup={elementOrderInGroup}
      reorderGroups={props.reorderGroups}
    />
    <div
      data-element-level={props.dataIndexes.length - 1}
      data-element-group={elementFromGroup}
      data-element-index={elementOrderInGroup}
      className='dragItem'
      draggable={!props.isHistoryDate}
    >
      <div className={props.updatedAt ? `statusButton ${props.status === 'finished' || props.status === 'cancelled' ? 'itemFinished' : ''} ${props.isHistoryDate ? 'disabled' : ''}` : ''}>
        <Tooltip id='status'/>
        {!isSelectingStatus && <box-icon
          type={statusIcon.type}
          name={statusIcon.name}
          color={statusIcon.color}
          size={statusIcon.size}
          onClick={(event) => props.isHistoryDate ? null : props.setIsSelectingStatus?.([elementFromGroup, elementOrderInGroup])}
          data-tooltip-id='status'
          data-tooltip-content={props.updatedAt ? `${t[props.lang][props.status]} ${localUpdatedAt}` : ''}
          data-tooltip-place='right'
        />}

        {isSelectingStatus && <>
          <box-icon
            type= 'regular'
            name= 'bulb'
            color= 'grey'
            size= 'md'
            onClick={(event) => props.changeStatus?.(props.dataIndexes, props.id, 'created')}
            data-tooltip-id='status'
            data-tooltip-content={`${t[props.lang]['changeStatusTo']} ${t[props.lang]['created']}`}
            data-tooltip-place='right'
          />
          <box-icon
            type='regular'
            name='run'
            color='orange'
            size='md'
            onClick={(event) => props.changeStatus?.(props.dataIndexes, props.id, 'started')}
            data-tooltip-id='status'
            data-tooltip-content={`${t[props.lang]['changeStatusTo']} ${t[props.lang]['started']}`}
            data-tooltip-place='right'
          />
          <box-icon
            type='regular'
            name='check'
            color='green'
            size='md'
            onClick={(event) => props.changeStatus?.(props.dataIndexes, props.id, 'finished')}
            data-tooltip-id='status'
            data-tooltip-content={`${t[props.lang]['changeStatusTo']} ${t[props.lang]['finished']}`}
            data-tooltip-place='right'
          />
          <box-icon
            type='regular'
            name='x'
            color='red'
            size='md'
            onClick={(event) => props.changeStatus?.(props.dataIndexes, props.id, 'cancelled')}
            data-tooltip-id='status'
            data-tooltip-content={`${t[props.lang]['changeStatusTo']} ${t[props.lang]['cancelled']}`}
            data-tooltip-place='right'
          />
          <box-icon
            type='regular'
            name='undo'
            color='grey'
            size='md'
            onClick={(event) => props.changeStatus?.(props.dataIndexes, props.id, 'undo')}
            data-tooltip-id='status'
            data-tooltip-content={`${t[props.lang]['undo']}`}
            data-tooltip-place='right'
          />
        </>}
      </div>
      <div className={`itemText ${props.status === 'finished' ? 'itemFinished' : ''}`}>
        {props.children}
      </div>
      <div className={`editButton ${props.isHistoryDate ? 'disabled' : ''}`}>
        <Tooltip id='edit-todo-item'/>
        <box-icon
          type='regular'
          name='pencil'
          color='DarkBlue'
          data-tooltip-id='edit-todo-item'
          data-tooltip-content={t[props.lang]['Edit']}
          data-tooltip-place='left'
          onClick={() => {
            if(props.isHistoryDate){
              return
            }
            localStorage.setItem('dragTo', JSON.stringify({itemFrom: elementOrderInGroup, groupFrom: elementFromGroup}))
            props.setSubPage('editItem')
            props.setCurrentDataIndexes(props.dataIndexes)
            props.setNewTextValue(props.itemText)
          }}
        />
      </div>
      <div className={`deleteButton ${props.isTheOnlyCategory || props.isHistoryDate ? 'disabled' : ''}`}>
        <Tooltip id='delete-todo-item'/>
        <box-icon
          type='solid'
          name='trash'
          color={props.isTheOnlyCategory ? 'grey' : 'firebrick'}
          data-tooltip-id='delete-todo-item'
          data-tooltip-content={props.isTheOnlyCategory ? t[props.lang]['No delete'] : t[props.lang]['Delete']}
          data-tooltip-place='left'
          onClick={() => {
            if(props.isHistoryDate){
              return
            }
            if(!props.isTheOnlyCategory){
              localStorage.setItem('dragTo', JSON.stringify({itemFrom: elementOrderInGroup, groupFrom: elementFromGroup}))
              props.setSubPage('deleteItem')
              props.setCurrentDataIndexes(props.dataIndexes)
            }
          }}
        />
      </div>
    </div>
  </>
}

export default DragItem